import HeaderSearch from './headerSearch'

export default HeaderSearch
